import React from "react";
import BoardToolbar from "../../components/agent-v3/board-toolbar/BoardToolbar";
import TopPanel, { WidgetType } from "../../components/agent-v3/top-panel/TopPanel";
import Board from "../../components/agent-v3/board/Board";
import { useTicketState } from "../../contexts/ticket-state/TicketState";
import { Loading } from "../../components";
import Chat from "../../components/agent-v3/chat/Chat";
import { Paths } from "../../contexts/Routing";
import { LoggingHandler } from "../../contexts/logging/LoggingContext";

export default function Agent() {
    const state = useTicketState();

    if (!state || state.isChatLoading) {
        return <Loading />;
    }
    return (
        <div className="w-100 h-100 d-flex flex-column">
            <TopPanel
                title="Conversations"
                activeWidgets={[
                    WidgetType.TOUR,
                    WidgetType.SEARCH,
                    WidgetType.APPROVALS,
                    WidgetType.SHORTCUTS,
                    WidgetType.HELP,
                    WidgetType.FEEDBACK,
                    WidgetType.CREATE_NEW,
                ]}
                metricPathPrefix={[LoggingHandler.Metrics.AGENT, "top-panel"]}
            />
            <BoardToolbar />
            <Board />
            <Chat />
        </div>
    );
}
